// import Message from '../models/message';
export default {
    groupArray: (arr, groupSize) => {
        let size = groupSize || 2
        if (arr != undefined) {
            return arr
            .filter((_, i) => i % size === 0)
            .map((obj, i) => {
                return {
                    ...obj,
                    content: obj.content + (arr[i * size + 1] ? "<br>" + arr[i * size + 1].content : ""),
                    // default de criação: 64px centralizado (padrão da maioria)
                    style: { fontSize: '64px', color: '#FFFFFF', textAlign: 'center', ...((obj.style && typeof obj.style === 'object') ? obj.style : {}) }
                }
            });
        } else {
            return arr;
        }
    },
    savePresentation: (presentation) => {
        return fetch('/api/presentation', {
            method: 'POST',
            body: JSON.stringify(presentation),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    loadPresentation: (playlistId) => {
        return fetch('/api/presentation/playlist/' + playlistId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    recreatePresentation: (playlistId) => {
        return fetch('/api/presentation/recreate/' + playlistId, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}